export default "__VITE_ASSET__b26777b3__"